import { useState, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchListing, ADMIN_DIGITS } from "@/lib/api";
import { pickRandomPalette, paletteVars } from "@/lib/palettes";
import { useSeo } from "@/lib/seo";
import { BadgeCheck, Sparkles, MessageCircle } from "lucide-react";
import ContactModal from "@/components/ContactModal";

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default function Listing() {
  const { city: citySlug, district: districtSlug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const P = useMemo(() => pickRandomPalette(`${citySlug}-${districtSlug || ""}-${Date.now()}`), [citySlug, districtSlug]);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    fetchListing(citySlug, districtSlug || null).then((d) => {
      if (!alive) return;
      if (d) setData({ ...d, ads: shuffle(d.ads) });
      else setData(null);
      setLoading(false);
    });
    return () => { alive = false; };
  }, [citySlug, districtSlug]);

  const cityName = data?.city?.name || "";
  const distName = data?.district?.name || "";
  const placeLabel = distName ? `${cityName} ${distName}` : cityName;
  const path = districtSlug ? `/${citySlug}/${districtSlug}/escort` : `/${citySlug}/escort`;
  const title = distName
    ? `${cityName} ${distName} Escort, ${cityName} ${distName} Vip Escort Hizmeti, Gerçek ve Premium Escort İlanları, Sınırsız Eskort`
    : `${cityName} Escort, ${cityName} Vip Escort Hizmeti, Gerçek ve Premium Escort İlanları, Sınırsız Eskort`;
  const desc = distName
    ? `${cityName} ${distName} Escort dünyasında premium hizmet sunan profillere ulaşın. Vip kalite ve sınırsız hizmet anlayışıyla ${distName} bölgesinde unutulmaz dakikalar sizi bekliyor.`
    : `${cityName} Escort dünyasında premium hizmet sunan profillere ulaşın. Vip kalite ve sınırsız hizmet anlayışıyla ${cityName} bölgesinde unutulmaz dakikalar sizi bekliyor.`;
  useSeo({ path, title, description: desc });

  if (loading) return <div className="np-loading" data-testid="loading">Yükleniyor…</div>;
  if (!data) return <div className="np-err" data-testid="err">Sayfa bulunamadı</div>;

  const bannerLabel = (distName ? distName : cityName).toLocaleUpperCase("tr-TR") + " ESCORT";

  const waMsg = `Merhaba ${placeLabel} Sitesinden Yazıyorum . İlan Vermek İçin Rahatsız Ediyorum.`;
  const waLink = `https://wa.me/${ADMIN_DIGITS}?text=${encodeURIComponent(waMsg)}`;

  const cityHomeUrl = `/${data.city.slug}/escort`;
  const adContextSlug = data.district ? `${data.city.slug}/${data.district.slug}` : data.city.slug;

  return (
    <div className="np-listing" data-testid="listing-page" style={paletteVars(P)}>
      <header className="np-header">
        <Link to="/" className="np-brand-link" data-testid="brand-home-link">
          <div className="np-brand">
            <span className="np-brand-deco">◆</span>
            <span className="np-brand-nova">NOVA</span>
            <span className="np-brand-amp">&amp;</span>
            <span className="np-brand-platinium">PLATİNİUM</span>
            <span className="np-brand-deco">◆</span>
          </div>
          <div className="np-brand-tagline">PREMİUM ESCORT SİTESİ</div>
        </Link>
      </header>

      <div className="np-banner" data-testid="city-banner">
        <span className="np-banner-text">{bannerLabel}</span>
      </div>

      <button
        className="np-cta"
        onClick={() => setModalOpen(true)}
        data-testid="cta-ilan-ver"
      >
        <Sparkles size={14} strokeWidth={2.5} />
        <span>İLAN VERMEK İÇİN TIKLAYINIZ</span>
      </button>

      <main className="np-ads-wrap">
        <div className="np-ads-grid" data-testid="ads-grid">
          {data.ads.map((ad, idx) => {
            const waUrl = ad.whatsapp_url || `https://kisalinks.com/${ad.id}`;
            return (
              <div key={ad.id} className="np-card" data-testid={`ad-card-${idx}`}>
                <Link
                  to={`/ilan/${ad.id}?c=${adContextSlug}`}
                  className="np-card-link"
                  data-testid={`ad-card-link-${idx}`}
                >
                  <div className="np-card-tag" data-testid={`tag-${idx}`}>{ad.tag}</div>
                  <div className="np-card-premium">PREMIUM HİZMET</div>

                  <img
                    src={ad.image_url}
                    alt={`${ad.name} - ${cityName} Escort`}
                    className="np-card-img"
                    loading="eager"
                    decoding="async"
                    referrerPolicy="no-referrer"
                  />
                  <div className="np-card-overlay" />

                  <div className="np-card-info">
                    <div className="np-card-name">
                      {ad.name}
                      {ad.verified && (
                        <BadgeCheck size={14} strokeWidth={3} className="np-card-check" data-testid={`verified-${idx}`} />
                      )}
                    </div>
                  </div>
                </Link>
                <a
                  href={waUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="np-card-wa"
                  data-testid={`card-wa-${idx}`}
                >
                  <MessageCircle size={14} strokeWidth={2.5} />
                  <span>WHATSAPP MESAJ</span>
                </a>
              </div>
            );
          })}
        </div>

        {data.all_districts && data.all_districts.length > 0 && (
          <section className="np-districts-strip">
            <h2 className="np-strip-title">{cityName} İLÇELERİ</h2>
            <div className="np-strip-grid">
              <Link
                to={cityHomeUrl}
                className={`np-strip-chip ${!data.district ? "active" : ""}`}
                data-testid="strip-il-merkez"
              >
                {cityName} Merkez
              </Link>
              {data.all_districts.map((d) => (
                <Link
                  key={d.slug}
                  to={`/${data.city.slug}/${d.slug}/escort`}
                  className={`np-strip-chip ${d.slug === data.district?.slug ? "active" : ""}`}
                  data-testid={`strip-${d.slug}`}
                >
                  {d.name}
                </Link>
              ))}
            </div>
          </section>
        )}
      </main>

      <footer className="np-foot">
        <p>© {new Date().getFullYear()} {placeLabel} ESCORT · NOVA &amp; PLATİNİUM</p>
      </footer>

      <ContactModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        waLink={waLink}
        displayPhone={`+${ADMIN_DIGITS.slice(0, 2)} ${ADMIN_DIGITS.slice(2, 5)} ${ADMIN_DIGITS.slice(5, 8)} ${ADMIN_DIGITS.slice(8, 10)} ${ADMIN_DIGITS.slice(10)}`}
      />
    </div>
  );
}
